import { registrarImpresionEtiquetas } from '@/services/etiquetas.js';
import { getLocalPrintingPreferences, getPrintingStatus, printEmittedLabels } from './directPrintService.js';

/**
 * Prints (or reprints) existing labels through Sinamon Print Agent. The printer is
 * checked first so the server only records prints that can actually be queued; the
 * server returns the labels re-rendered for the configured resolution, never new codes.
 */
export async function imprimirEtiquetas(labels, { motivo, scope = {} } = {}) {
  const ids = (labels || []).map((label) => Number(label.id)).filter(Boolean);
  if (!ids.length) throw new Error('Seleccione al menos una etiqueta para imprimir.');

  const { labelPrinter, labelDpi } = getLocalPrintingPreferences(scope);
  if (!labelPrinter) throw new Error('Configure la impresora de etiquetas en Configuración › Impresión.');
  const status = await getPrintingStatus(scope);
  if (status.state !== 'connected') throw new Error('Sinamon Print Agent no está conectado en esta computadora.');
  if (!status.printers.includes(labelPrinter)) {
    throw new Error(`La impresora de etiquetas “${labelPrinter}” no está disponible en este equipo.`);
  }

  const registradas = await registrarImpresionEtiquetas(ids, { dpi: labelDpi, motivo });
  return printEmittedLabels(registradas, { printerName: labelPrinter, scope });
}
